import dragula from "dragula";

const SCROLL_SPEED = 10;
const EDGE_SIZE = 100;

/**
 * Create a dragula instance for module reordering.
 *
 * Enables horizontal auto-scroll near container edges when in horizontal mode.
 *
 * @param {HTMLElement} container - The container element
 * @param {Object} [options]
 * @param {boolean} [options.horizontal=false] - Horizontal layout with auto-scroll near edges
 * @param {Function} [options.onDrop] - Callback when drop occurs
 * @param {Function} [options.moves] - Dragula `moves` predicate
 * @param {Function} [options.accepts] - Dragula `accepts` predicate
 */
export function createModulesReordering(container, options = {}) {
  const { horizontal = false, onDrop, ...dragulaOptions } = options;

  const config = {
    mirrorContainer: document.body,
    ...dragulaOptions,
  };
  if (horizontal) config.direction = "horizontal";

  const drake = dragula([container], config);

  if (horizontal) setupAutoScroll(drake, container);
  if (onDrop) drake.on("drop", onDrop);
}

function setupAutoScroll(drake, container) {
  let rafId = null;
  let mirror = null;

  drake.on("cloned", (clone, _original, type) => {
    if (type === "mirror") mirror = clone;
  });

  drake.on("drag", () => {
    const tick = () => {
      if (mirror) {
        const containerRect = container.getBoundingClientRect();
        const mirrorRect = mirror.getBoundingClientRect();

        if (mirrorRect.left < containerRect.left + EDGE_SIZE && mirrorRect.right > containerRect.left) {
          container.scrollLeft -= SCROLL_SPEED;
        }
        if (mirrorRect.right > containerRect.right - EDGE_SIZE && mirrorRect.left < containerRect.right) {
          container.scrollLeft += SCROLL_SPEED;
        }
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);
  });

  // `dragend` always fires after `drop` or `cancel`, so one listener is enough.
  drake.on("dragend", () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    mirror = null;
  });
}
